import instanceAxios from '../config/api'
import { License, LicensePlan, SubscriptionPlanCatalogItem } from '../types/license'

const API_URL = '/license'

export const getMyLicenseApi = async (): Promise<License> => {
  const response = await instanceAxios.get<License>(`${API_URL}/me`)
  return response.data
}

export const getLicensePlansApi = async (): Promise<SubscriptionPlanCatalogItem[]> => {
  const response = await instanceAxios.get<SubscriptionPlanCatalogItem[]>(`${API_URL}/plans`)
  return response.data
}

export const changeLicensePlanApi = async (planKey: LicensePlan): Promise<License> => {
  const response = await instanceAxios.put<License>(`${API_URL}/me/plan`, { planKey })
  return response.data
}
